import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate,useLocation } from 'react-router-dom';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL,NT_STATUS,getSpinner} from './../constants';
import axios from 'axios';
import {stringToHex, validateInput} from "./../components/forms/validator";
import Waiter from './../assets/gif/blueCircle.gif';
let __assetInfo__={
    token:"",
    assetId:"0.00",
    payDate:"",
    paymentAmount:"0.00",
    remark:""
    
};
const JComponent= ({route}) => {
    const navigate=useNavigate();
    const location=useLocation();
    const [assetsCategoryList,setAssetsCategoryList]=useState([]);
	const [implAgencyList,setImplAgencyList]=useState([]);
  	const [fundingAgencyList,setFundingAgencyList]=useState([]);
  	const [userAgencyList,setUserAgencyList]=useState([]);
    const [rows,setRows]=useState([]);
    const [fetchOnReq,setFecthOnReq]=useState(false);
    const [assetId,setAssetId]=useState("");
    const [cols,setCols]=useState([]);
    //---------------- init---------------------------//
    const getAssetType=(_catId)=>{
		for(let i=0;i<assetsCategoryList.length;i++){
			if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
		}
		return(_catId);
	}
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const getUserAgencyById=(_id)=>{
		for(let i=0;i<userAgencyList.length;i++){
			if(userAgencyList[i].userAgencyId===_id) return(userAgencyList[i].userAgencyName);
		}
		return(_id);
	}
	const loadAssetCategoryList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_asset_category.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setAssetsCategoryList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadImplAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadFundingAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_funding_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setFundingAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadUserAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_user_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setUserAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
      const loadPaymentInfo=()=>{
        let _rows=[];

		setRows([]);
			let _d={
					token:localStorage.getItem("_xoxex"),
				};
			let idata=stringToHex(JSON.stringify(_d));	
			setFecthOnReq(true);	
			var config = {
				method: 'post',
				url: API_CORE_SERVER+"/api/payment/payment.list.php",
				headers: { 
					'Content-Type': 'application/json', 
				},
				data:_d
			  };
			  axios(config).then(response=>{
				if(response.status===200 && response.data){
					let data=response.data;
					if(data.status===1 && data.data && data.data.length>0){
						let records=data.data;
						for(let i=0;i<records.length;i++){
							let assetId=records[i].assetId;
							try{
									let rec=JSON.parse(records[i].asset_rec);
									console.log(rec);
									_rows.push({ 
                                        payDate:records[i].payDate,
                                        paymentAmount:records[i].paymentAmount,
                                        assetId:assetId,
										assetType:rec.assetInfo.assetType,
										assetName:rec.assetInfo.assetName,
										implementAgency:rec.assetInfo.implementAgency,
										fundingAgency:rec.assetInfo.fundingAgency,
										userAgency:rec.assetInfo.userAgency,
										assetDescription:rec.assetInfo.assetDescription,
										panchayat:rec.assetInfo.panchayat,
										address:rec.assetInfo.address,
										village:rec.assetInfo.village,
										block:rec.assetInfo.block,
										beneficiary:rec.assetInfo.beneficiary,
										agrCost:rec.assetDetail.agrCost,
										agrDate:rec.assetDetail.agrDate,
										estCost:rec.assetDetail.estCost,
										estWorkStartDate:rec.assetDetail.estWorkStartDate,
										estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
										workStartDate:rec.assetDetail.workStartDate,
										workFinishDate:rec.assetDetail.workFinishDate,
										workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
										workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
										lat:rec.assetDetail.lat,
										lng:rec.assetDetail.lng,
										cname:rec.contractorInfo.name,
										photos:rec.assetDetail.photos,
										contractor:rec.contractorInfo
									});
								}catch(e){
									console.log("exp:assetId:"+assetId);
								}
						}
					}
				}
				
				setFecthOnReq(false);
			});
			setRows(_rows);
			
		}
      
    //----------------- end init-----------------------//
    useEffect(()=>{
        setCols([
            "Date",
            "Payment",
            "Contractor",
			"Asset.Type",
			"Asset.Name",
			"Dept",
			"Panchayat",
			"Block",
			"Agr.Cost",
			"Agr.Date",
			"Work\nStart",
			"Work\nStatus",
			"Work(%)\nProgress",
			
			
		]);
        loadPaymentInfo();
        loadAssetCategoryList();
		loadImplAgencyList();
		loadUserAgencyList();
		loadFundingAgencyList();
        setTimeout(()=>{
            
                window["initTable"]("w3PListTable");
        
        },2000);
    },[])
   

   
    return(
        <>
        <h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Payments</h5>
		<div className='row'>
		<div className='col-md-8 p-4'>
            <div className='px-4 py-4'>
                <div className="" >
                {fetchOnReq===true && 
                    <>
                        <img src={Waiter} className='waiter-md'/>
                    </>
                }
                {(fetchOnReq===false && rows.length>=1) && 
                
                    <table id="w3PListTable" className="table table-sm" style={{fontSize:'0.85rem'}}>
                        <thead>
                            <tr>
                                <th><span>Slno</span></th>
                                {cols.map((item,i)=>{
                                    return(
                                        <th key={'tfx423_'+i}><span>{item}</span></th>	
                                    )
                                })
                                }
                            
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((item,i)=>{
                                    return(
                                        
                                        <tr key={'t423_'+i}>
                                            <td>{(i+1)}</td>
                                            <td><div className='badge bg-info'>{item.payDate}</div></td>
                                            <td align='right' className='fw-bold'>{item.paymentAmount}</td>
                                            <td>{item.cname}</td>
                                            <td>{getAssetType(item.assetType)}</td>
											<td>{item.assetName}</td>
                                            <td>{getImplAgencyById(item.implementAgency)}</td>
                                            <td>{item.panchayat}</td>
                                            <td>{item.block}</td>
                                            <td align='right'>{item.agrCost}</td>
                                            <td nowrap>{item.agrDate}</td>
                                            <td nowrap>{item.workStartDate}</td>
                                            <td >{item.workStatus}</td>
                                            <td align='center'>{item.workProgress}</td>
                                        </tr>	
                                    )
                        })
                        }
                        </tbody>
                        
                    </table>
                }
                </div>
            </div>
        </div>    
        <div className='col-md-4 p-4'>
        	<div className='px-4 py-4'>
                <div className="" >
                
                </div>
            </div>
        </div>
        </div>    
        </>
    )
}
export default JComponent;
